///////////////////////////////
// IMPORTING MODULES
///////////////////////////////

import React from "react";
import { scrollToSection } from "../lib/utils";
import { useNavigate } from "react-router-dom";

///////////////////////////////
// COMPONENT: FOOTER
///////////////////////////////

const Footer = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <footer className="bg-[#0e1220] border-t border-gray-800 py-12 pl-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="../images/logo.png"
                width={70}
                className="mr-2"
                alt="Flight Trail Logo"
              />

              <span className="text-xl font-bold">Flight Trail</span>
            </div>
            <p className="text-gray-400 mb-4">
              Track your travels on an interactive 3D globe. Every airport,
              every country, every adventure beautifully mapped.
            </p>
            <p className="text-sm text-gray-500">
              © 2025 Flight Trail. All rights reserved.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("home")}
                  className="text-gray-400 hover:text-[#2ab8ff] transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("features")}
                  className="text-gray-400 hover:text-[#2ab8ff] transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("faq")}
                  className="text-gray-400 hover:text-[#2ab8ff] transition-colors"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button className="cursor-pointer text-gray-400 hover:text-[#2ab8ff] transition-colors bg-none border-none">
                  Demo
                </button>
                <p className="text-gray-400 text-xs">Shown in App</p>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="text-gray-400 hover:text-[#2ab8ff] transition-colors"
                >
                  Contact
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/privacy-policy")}
                  className="text-gray-400 hover:text-[#2ab8ff] transition-colors"
                >
                  Privacy Policy and Terms of Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/delete-account")}
                  className="text-gray-400 hover:text-[#2ab8ff] transition-colors"
                >
                  Delete Account
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

///////////////////////////////
// EXPORTING FOOTER
///////////////////////////////

export default Footer;
